import { AbstractDTO } from "@signature-it/ngx-generic/models";
import { GenericConfig } from "@signature-it/ngx-generic/config";

export class PriceDTO extends AbstractDTO {
    value: number;
    currency: string;
    id: number;
    striped: number;
    hideStripedElements: boolean;
    clubPrice: number;
    clubStripedPrice: number;
    exclusive: string;
    autoshipment_s: boolean;
    autoshipment_text_s: string;
    autoShipmentPrice: number;
    autoshipment_minimum_amount_s: number;
    fractionDigitsInt: string;
    fractionDigitsStripedInt: string;
    fractionDigitsTotalSavedInt: string;
    fractionDigitsClubPriceInt: string;
    fractionDigitsClubStripedPriceInt: string;
    fractionDigits: string;
    fractionDigitsStriped: string;
    fractionDigitsTotalSaved: string;
    fractionDigitsClubPrice: string;
    fractionDigitsClubStripedPrice: string;

    constructor(attributes: object) {
        super(attributes);
        attributes = attributes ? attributes : {};

        const fractionDigits = typeof(GenericConfig.priceFractionDigits) === 'number' ? GenericConfig.priceFractionDigits : 2;

        this.id = attributes['id'] || -1;
        this.value = attributes['price'] ? parseFloat(attributes['price']) : -1;
        this.striped = attributes['stripedPrice'] ? parseFloat(attributes['stripedPrice']) : -1;
        this.hideStripedElements = attributes['hideStripedElements'] || false;
        this.currency = attributes['currency'] || '';
        this.clubPrice = attributes['clubPrice'] ? parseFloat(attributes['clubPrice']) : -1;
        this.clubStripedPrice = attributes['clubStripedPrice'] ? parseFloat(attributes['clubStripedPrice']) : -1;
        this.exclusive = attributes['exclusive'] || '';
        this.autoshipment_s = attributes['autoshipment_s'] ? attributes['autoshipment_s'] : null;
        this.autoShipmentPrice = attributes['autoShipmentPrice'] ? parseFloat(attributes['autoShipmentPrice']) : this.value;
        this.autoshipment_minimum_amount_s = attributes['autoshipment_minimum_amount_s'] ? parseInt(attributes['autoshipment_minimum_amount_s']) : 0;
        this.autoshipment_text_s = attributes['autoshipment_text_s'] || '';
        this.fractionDigitsInt = attributes['price'] ? attributes['price'].toString().split('.')[0] : '';
        this.fractionDigitsStripedInt = attributes['stripedPrice'] ? attributes['stripedPrice'].toString().split('.')[0] : '';
        this.fractionDigitsClubPriceInt = attributes['clubPrice'] ? attributes['clubPrice'].toString().split('.')[0] : '';
        this.fractionDigitsClubStripedPriceInt = attributes['clubStripedPrice'] ? attributes['clubStripedPrice'].toString().split('.')[0] : '';
        this.fractionDigitsTotalSavedInt = attributes['stripedPrice'] && attributes['price'] ? (attributes['stripedPrice'] - attributes['price']).toString().split('.')[0] : '';

        this.fractionDigits = attributes['price'] ? Number(attributes['price']).toFixed(fractionDigits).toString().split('.')[1]: '';
        this.fractionDigitsStriped = attributes['stripedPrice'] ? Number(attributes['stripedPrice']).toFixed(fractionDigits).toString().split('.')[1] : '';
        this.fractionDigitsClubPrice = attributes['clubPrice'] ? Number(attributes['clubPrice']).toFixed(fractionDigits).toString().split('.')[1] : '';
        this.fractionDigitsClubStripedPrice = attributes['clubStripedPrice'] ? Number(attributes['clubStripedPrice']).toFixed(fractionDigits).toString().split('.')[1] : '';
        this.fractionDigitsTotalSaved = attributes['stripedPrice'] && attributes['price'] ? (Number(attributes['stripedPrice']) - Number(attributes['price'])).toFixed(fractionDigits).toString().split('.')[1] : '';

        if (this.value >= this.striped) {
            this.striped = -1;
        }

    }
}
